import { render, staticRenderFns } from "./Basepage.vue?vue&type=template&id=87660872"
import script from "./Basepage.vue?vue&type=script&lang=js"
export * from "./Basepage.vue?vue&type=script&lang=js"
import style0 from "./Basepage.vue?vue&type=style&index=0&id=87660872&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports